import React, { useEffect, useState } from "react";
import { Content, Button } from "adminlte-2-react";
import { getPages, createPage, deletePage } from "../../api/pages";
import { hasPermission } from "../../helpers";
import { useAuthContext } from "../../context/AuthContext";
import { slugify } from "transliteration";

function Pages(props) {
	const { updateMenu } = props;

	const [pages, setPages] = useState([]);
	const [newPageName, setNewPageName] = useState("");
	const [error, setError] = useState(null);
	const { permission } = useAuthContext();

	const loadPages = async () => {
		try {
			setPages(await getPages());
		} catch (e) {
			setError(e.message);
		}
	};

	useEffect(() => {
		loadPages();
	}, []);

	const handleCreate = async () => {
		if (!newPageName.trim()) return;
		try {
			const pageName = newPageName.trim();
			await createPage({
				name: pageName,
				slug: slugify(pageName),
				description: "",
			});
			setNewPageName("");
			await loadPages();
			if (updateMenu) await updateMenu();
		} catch (e) {
			setError(e.message);
		}
	};

	const handleDelete = async (id) => {
		try {
			await deletePage(id);
			await loadPages();
			if (updateMenu) await updateMenu();
		} catch (e) {
			setError(e.message);
		}
	};

	return (
		<Content title="Страницы">
			{error && <div className="alert alert-danger">{error}</div>}

			{hasPermission(permission, "api::page", "page", "create") && (
				<div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
					<input
						value={newPageName}
						onChange={(e) => setNewPageName(e.target.value)}
						placeholder="Название новой страницы"
					/>
					<Button text="Создать страницу" onClick={handleCreate} />
				</div>
			)}

			<ul style={{ listStyle: "none", padding: 0 }}>
				{pages.map((p) => (
					<li
						key={p.id}
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							padding: "8px 0",
							borderBottom: "1px solid #dee2e6",
						}}
					>
						<Button to={`/pages/${p.id}`} text={p.name} />

						{hasPermission(permission, "api::page", "page", "delete") && (
							<button
								onClick={() => handleDelete(p.id)}
								style={{ border: "none", background: "none" }}
							>
								Удалить
							</button>
						)}
					</li>
				))}
			</ul>
		</Content>
	);
}

export default Pages;
